import { render } from "./HomeTypeView.vue?vue&type=template&id=60b0c3fa"
import script from "./HomeTypeView.vue?vue&type=script&lang=js"
export * from "./HomeTypeView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__